const en = {
  'questionnaire.list.submit': 'View the results',
  'questionnaire.list.isSending': 'Busy sending',
  'questionnaire.list.error':
    'Due to a technical malfunction, we are unfortunately unable to perform a calculation at the moment. Try it again.',
  'questionnaire.result.back': `Back to the test`,
  'questionnaire.result.viewExplanation': `View the explanation`,
  'questionnaire.result.closeExplanation': `Hide explanation`
};
export default en;
